module.exports = __webpack_public_path__ + "img/pt_br.9f24ef1b.png";